import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SystemEventListPanel } from "@/features/admin/components/system-event-list-panel";

const SECTIONS = [
  { value: "VID_FEATURES", label: "Software Features" },
  { value: "VID_TRANSCRIPTS", label: "e-Services & Transcripts" },
  { value: "VID_TOOLBOX", label: "Marketing Toolbox" },
  { value: "VID_SETUP", label: "Software Setup" },
  { value: "VID_EDUCATION", label: "Continuing Education" },
] as const;

/**
 * Video library editor (`/admin/videos`) — five ordered sections. Fields are
 * entered manually (Vimeo auto-lookup is deferred per §12): `detail` holds the
 * thumbnail image URL, `href` the embed/link URL.
 */
export default function VideosPage() {
  return (
    <Tabs defaultValue={SECTIONS[0].value}>
      <TabsList className="flex-wrap">
        {SECTIONS.map((s) => (
          <TabsTrigger key={s.value} value={s.value}>
            {s.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {SECTIONS.map((s) => (
        <TabsContent key={s.value} value={s.value} className="mt-4">
          <SystemEventListPanel
            title={s.label}
            description="Enter the thumbnail image URL (detail) and embed link (URL) manually."
            addLabel="Add video"
            resource="videos"
            selector={{ param: "section", value: s.value }}
            fields={["title", "detail", "href"]}
            columns={[
              { header: "Title", cell: (e) => <span className="font-medium">{e.title}</span> },
              { header: "Embed URL", cell: (e) => e.href || "—" },
            ]}
          />
        </TabsContent>
      ))}
    </Tabs>
  );
}
